import { render, staticRenderFns } from "./BudgetCategory.vue?vue&type=template&id=d9fd76ca"
import script from "./BudgetCategory.vue?vue&type=script&lang=js"
export * from "./BudgetCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports